/**
 * @generated SignedSource<<24c6c5b75b824010259d3b30e0b68fdd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InspectionForm$data = {
  readonly answers: any;
  readonly approvedDate: any | null;
  readonly executionDate: any | null;
  readonly id: string;
  readonly images: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly downloadUrl: string | null;
        readonly filename: string | null;
        readonly key: any;
        readonly metaData: any | null;
        readonly thumbnailUrl: string | null;
        readonly uploadedOn: any | null;
      } | null;
    } | null>;
  };
  readonly inspectionfield: {
    readonly field: {
      readonly " $fragmentSpreads": FragmentRefs<"FieldDetailsFragment" | "FieldMap">;
    } | null;
    readonly managementPackageSetting: {
      readonly pdfFileUrl: string | null;
    } | null;
    readonly plannedDate: any | null;
    readonly state: InspectionfieldStateEnum | null;
    readonly year: number;
  };
  readonly inspectionform: {
    readonly addAdvice: boolean;
    readonly addPhotoEndresult: boolean;
    readonly steps: any;
  } | null;
  readonly notes: any;
  readonly rejectedDate: any | null;
  readonly retry: boolean;
  readonly retryDate: any | null;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionForm_data">;
  readonly " $fragmentType": "InspectionForm";
};
export type InspectionForm$key = {
  readonly " $data"?: InspectionForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionForm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionForm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionFormNode",
      "kind": "LinkedField",
      "name": "inspectionform",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "steps",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "addAdvice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "addPhotoEndresult",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionfieldNode",
      "kind": "LinkedField",
      "name": "inspectionfield",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plannedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "year",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ManagementPackageSettingsNode",
          "kind": "LinkedField",
          "name": "managementPackageSetting",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pdfFileUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FieldNode",
          "kind": "LinkedField",
          "name": "field",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FieldMap"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FieldDetailsFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorageObjectNodeConnection",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StorageObjectNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StorageObjectNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "metaData",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "filename",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "downloadUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumbnailUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uploadedOn",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approvedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejectedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "executionDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retryDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InspectionForm_data"
    }
  ],
  "type": "InspectionNode",
  "abstractKey": null
};

(node as any).hash = "0e80a60a0c5205fdd3f565de0bb0d92d";

export default node;
